import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from '../shared/grid/crud.service';
import { DashboardViewWidget } from '../models/dashboard-view-widget.model';

interface DashboardViewWidgetDto extends Omit<DashboardViewWidget, 'configJson'> {
  configJson: string;
}

@Injectable({ providedIn: 'root' })
export class DashboardViewWidgetService extends CrudService<DashboardViewWidget> {
  constructor(http: HttpClient) {
    super('DashboardViewWidget', http);
  }

  private serializeWidget(widget: DashboardViewWidget | Partial<DashboardViewWidget>): DashboardViewWidgetDto | Partial<DashboardViewWidgetDto> {
    return {
      ...widget,
      configJson: typeof widget.configJson === 'string' ? widget.configJson : JSON.stringify(widget.configJson ?? {})
    } as DashboardViewWidgetDto;
  }

  override create(payload: DashboardViewWidget): Observable<DashboardViewWidget> {
    return this.http.post<DashboardViewWidget>(this.getApiUrl(`${this.controllerName}/Create`), this.serializeWidget(payload));
  }

  override update(payload: DashboardViewWidget): Observable<Object> {
    return this.http.post(this.getApiUrl(`${this.controllerName}/Update`), this.serializeWidget(payload));
  }

  override createRange(payload: DashboardViewWidget[]): Observable<Object> {
    return this.http.post<DashboardViewWidget[]>(
      this.getApiUrl(`${this.controllerName}/CreateRange`),
      payload.map(w => this.serializeWidget(w))
    );
  }
}
